import React, { Fragment } from 'react'
import Logo from '../../../../assets/Logo.png'
import './style.scss'

const CreditNavbar = () => (
  <Fragment>
    <div className='navbar'>
      <div>
        <img src={Logo} alt='logo_mellro' className='navbar_logo' />
      </div>
      <div className='navbar_header'>
        <div className='navbar_title'>
          <div className='navbar_text'>Avaliação de Crédito</div>
        </div>
      </div>
    </div>
    <div className='message'>
      <p className='message_text'>Você tem um interessado em seu imóvel e precisa</p>
      <p className='message_text'>verificar o credito dele? Com esse passo a passo fica</p>
      <p className='message_text'>fácil e sai instantaneamente para você. Também</p>
      <p className='message_text'>mandamos para seu email a consulta para você guardar.</p>

      <p className='message_text message_top'>A consulta vai preencher um resultado como abaixo:</p>
    </div>
  </Fragment>
)

export default CreditNavbar
